import './social-wall.scss';

class SocialWall {
    constructor (element) {
        this.$socialWall = element;
        this.loadMoreButtonClass = 'flockler-btn-load-more';
        this.$loadMoreButton = null;
        this.$content = this.$socialWall.querySelector('[data-social-wall="content"]');
        this.observer = null;
        this.found = false;
    }

    initialize () {
        this.startObserver();
    }

    startObserver () {
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'subtree' || !this.found) {
                    this.$loadMoreButton = this.$socialWall.querySelector('.' + this.loadMoreButtonClass);
                    if (this.$loadMoreButton) {
                        this.found = true;
                        this.$loadMoreButton.classList.add(this.loadMoreButtonClass + '-ek');
                    }
                }
            }
            this.found = false;
        };

        this.observer = new MutationObserver(callback);

        this.observer.observe(this.$content, {
            childList: true,
            subtree: true
        });
    }

    stopObserver () {
        this.observer.disconnect();
    }
}

export { SocialWall };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const startSocialWalls = ($socialWalls) => {
        $socialWalls.forEach(($socialWall) => {
            const $placeholder = $socialWall.querySelector('.media__restriction');

            const $socialWallClass = new SocialWall($socialWall);
            $socialWallClass.initialize();

            if ($placeholder) {
                $placeholder.remove();
            }
        });
    };

    if ($context) {
        const $socialWalls = $context.querySelectorAll('[data-social-wall="root"]');

        if ($socialWalls.length > 0) {
            const waitForConsent = setInterval(() => {
                if (typeof OneTrust !== 'undefined') { // eslint-disable-line
                    if (OnetrustActiveGroups.indexOf('C0010') != -1) { // eslint-disable-line
                        startSocialWalls($socialWalls);
                    } else {
                        $socialWalls.forEach(($socialWall) => {
                            const $placeholder = $socialWall.querySelector('.media__restriction');
                            const $button = $socialWall.querySelector('[data-restriction="remove"]');

                            if ($button) {
                                $button.addEventListener('click', () => {
                                    if (typeof OneTrust.UpdateConsent !== 'undefined') { // eslint-disable-line
                                        OneTrust.UpdateConsent("Category", "C0010:1"); // eslint-disable-line
                                    } else {
                                        OneTrust.ToggleInfoDisplay(); // eslint-disable-line
                                    }
                                });
                            }

                            if ($placeholder) {
                                $placeholder.classList.add('is--shown');
                                $placeholder.closest('[data-social-wall="content"]')?.classList.add('has--restriction');
                            }
                        });

                        OneTrust.OnConsentChanged(() => { // eslint-disable-line
                            if (OnetrustActiveGroups.indexOf('C0010') != -1) { // eslint-disable-line
                                startSocialWalls($socialWalls);
                            }
                        });
                    }
                    clearInterval(waitForConsent);
                }
            }, 300);
        }
    }
});
